import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Injectable, OnDestroy, signal } from "@angular/core";
import { combineLatest, fromEvent, Subject, tap } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ViewportInfo } from "../models/singleTypes/viewport-info.mode";
import { DeviceType } from "../shared/enums/deviceType.enum";
import { OrientationType } from "../shared/enums/orientationType.enum";

@Injectable({
  providedIn: "root",
})

export class ResponsiveService implements OnDestroy {
  onWindowResize$ = new Subject<ViewportInfo>();
  viewportInfo = signal<ViewportInfo>({
    width: window.innerWidth,
    height: window.innerHeight,
    device: DeviceType.Desktop,
    orientation: OrientationType.Landscape,
  });
  private destroy$ = new Subject<void>();

  constructor(private breakpointObserver: BreakpointObserver) {
    this.updateViewport();

    fromEvent(window, "resize")
      .pipe(
        takeUntil(this.destroy$),
        tap(() => this.updateViewport())
      )
      .subscribe();

    combineLatest([
      this.breakpointObserver.observe(Breakpoints.Handset),
      this.breakpointObserver.observe(Breakpoints.Tablet),
      this.breakpointObserver.observe(Breakpoints.Web),
    ]).pipe(
      takeUntil(this.destroy$))
      .subscribe(([handset, tablet]) => {
        let deviceType: DeviceType;

        if (handset.matches) deviceType = DeviceType.Mobile;
        else if (tablet.matches) deviceType = DeviceType.Tablet;
        else deviceType = DeviceType.Desktop;

        this.viewportInfo.update(x => ({ ...x, device: deviceType }));
      });
  }

  private updateViewport() {
    const width = window.innerWidth;
    const height = window.innerHeight;

    const orientation =
      height >= width
        ? OrientationType.Portrait
        : OrientationType.Landscape;

    const current = this.viewportInfo();
    this.viewportInfo.set({
      ...current,
      width,
      height,
      orientation,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}